module.exports = __webpack_public_path__ + "img/6.3c1c324e.png";